import { Text } from '~/commonComponents';
import { Colors } from '../../../../../themes/colors';

interface ITitleProps {
  text: string;
  isRequired?: boolean;
}

export const Title = ({ text, isRequired = false }: ITitleProps) => (
  <Text color={Colors.neutral_600} fontSize={18} fontWeight={700}>
    {text}

    {isRequired && (
      <Text color={Colors.neutral_500} fontSize={16} marginLeft={4}>
        (Required)
        <Text color={Colors.error_500} fontSize={16}>
          *
        </Text>
      </Text>
    )}
  </Text>
);
